/* eslint-disable no-nested-ternary */
import styled from '@emotion/styled';
import { mediaQuery } from '@presentation/styles';
import type { InputRadioVariant } from './types';

export const Container = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
`;

export const SeparatedContainer = styled(Container)`
  gap: 16px;
`;

export const Wrapper = styled.div<{
  active: boolean;
  disabled: boolean;
  grow: boolean;
  hasError: boolean;
  autoHeight?: boolean;
  variant?: InputRadioVariant;
}>`
  padding: 0px 10px;
  border: 2px solid ${(props) => props.theme.color.light.shade};
  color: ${(props) => props.theme.color.medium.default};
  background: ${(props) => props.theme.color.light.default};
  position: relative;
  z-index: 0;
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
  height: 38px;
  line-height: 38px;
  ${(props) => props.autoHeight && 'height: auto;'}
  ${(props) =>
    props.disabled &&
    `
    background: ${props.theme.color.blue.lightBlue};
  `}
  ${(props) =>
    props.active &&
    (props.disabled
      ? `
    z-index: 1;
  color: ${
    props.variant === 'blue' ? props.theme.color.light.default : props.theme.color.medium.default
  };
  background: ${props.theme.color.blue.lightBlue};
  `
      : `
    z-index: 1;
  border-right: 2px solid ${props.theme.color.blue.default} !important;
  border-color: ${props.theme.color.blue.default};
  color: ${props.theme.color.blue.default};
  background: ${props.theme.color.blue.lightBlue};
  `)}
  &:first-of-type {
    border-radius: 10px 0 0 10px;
  }
  &:not(:last-child) {
    border-right: 2px solid transparent;
    margin-right: -2px;
  }
  &:last-child {
    border-radius: 0 10px 10px 0;
  }
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: nowrap;
  white-space: nowrap;

  font-size: 14px;
  /* white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden; */

  ${(props) => props.hasError && `border: 2px solid ${props.theme.color.red.default} !important;`}

  ${(props) => props.grow && 'flex: 1;'}
`;

export const SeparatedWrapper = styled.div<{
  active: boolean;
  disabled: boolean;
  grow: boolean;
  hasError: boolean;
  autoHeight?: boolean;
  autoWidth?: boolean;
  hideSelectedIcon?: boolean;
  langSelector?: boolean;
  variant?: InputRadioVariant;
}>`
  position: relative;
  padding: 16px;
  ${(props) => props.autoHeight && 'height: auto;'}
  ${(props) => (props.autoWidth ? 'flex: 1' : '')};
  ${(props) => (props.langSelector ? 'width: calc(33% - 16px);' : 'width: calc(50% - 16px);')}
  background: ${(props) => props.theme.color.light.default};
  color: ${(props) =>
    props.variant === 'blue' ? props.theme.color.medium.default : props.theme.color.medium.shade};
  border: 2px solid ${(props) => props.theme.color.light.shadeLighter};
  border-radius: 6px;
  position: relative;
  z-index: 0;
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};

  ${mediaQuery('small')} {
    ${(props) =>
      props.langSelector
        ? 'display: flex:1;width: calc(50% - 8px); padding:8px;'
        : 'width: 100%;flex: auto;'}
  }

  ${(props) =>
    props.disabled &&
    `
      background: ${props.theme.color.light.shadeLighter};
    `}

  ${(props) =>
    props.active &&
    `
    z-index: 1;
    border-color: ${
      props.variant === 'blue' ? props.theme.color.blue.default : props.theme.color.blue.lightBlue
    };
    background: ${props.theme.color.light.default};
  `}

  ${(props) =>
    props.active &&
    !props.hideSelectedIcon &&
    (props.variant === 'blue'
      ? `
    &:after {
      content: "";
      position: absolute;
      top: 13px;
      right: 15px;
      background: ${props.theme.color.blue.default};
      width: 25px;
      height: 25px;
      border-radius: 50%;
    }

    &:before {
      content: "";
      position: absolute;
      top: 17px;
      right: 10px;
      background: url("data:image/svg+xml,%3Csvg stroke='white' fill='white' stroke-width='0' viewBox='0 0 512 512' height='1em' width='1em' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill='none' stroke-linecap='round' stroke-linejoin='round' stroke-width='92' d='M416 128L192 384l-96-96'%3E%3C/path%3E%3C/svg%3E") no-repeat;
      width: 25px;
      height: 25px;
      z-index: 1;
    }
  `
      : `
  &:after {
    content: "";
    position: absolute;
    top: -15px;
    right: 15px;
    background: ${props.theme.color.blue.default};
    width: 25px;
    height: 25px;
    border-radius: 50%;
  }

  &:before {
    content: "";
    position: absolute;
    top: -10px;
    right: 10px;
    background: url("data:image/svg+xml,%3Csvg stroke='white' fill='white' stroke-width='0' viewBox='0 0 512 512' height='1em' width='1em' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill='none' stroke-linecap='round' stroke-linejoin='round' stroke-width='92' d='M416 128L192 384l-96-96'%3E%3C/path%3E%3C/svg%3E") no-repeat;
    width: 25px;
    height: 25px;
    z-index: 1;
  }
`)}

  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: nowrap;

  font-size: 14px;
`;

export const IconRightWrapper = styled.div<{ hasLabel: boolean }>`
  ${(props) => props.hasLabel && 'margin-left: 5px;'}
  img {
    vertical-align: middle;
  }
`;

export const IconLeftWrapper = styled.div<{ hasLabel: boolean }>`
  ${(props) => props.hasLabel && 'margin-right: 5px;'}
  img {
    vertical-align: middle;
  }
`;
